export const TYPES = {
    CATEGORY: 'category',
    SUB_CATEGORY: 'sub_category',
    STORE: 'store',
    SEARCH_QUERY: 'search_query',
    NESTED_SUB_CATEGORY: 'nested_sub_category',
    STATIC_PAGE: 'static_page',
    FILTERED_PAGE: 'filtered_page',
    FILTERED_SUB_CATEGORY: 'filtered_sub_category',
    PLACEHOLDER: 'placeholder',
    MENU_PANEL: 'menu_panel',
    STATIC: 'static',
    LOGO_MAKER_IDEAS: 'ideas',
    CONTENT_PAGE: 'content_page',
    LANDING_PAGE: 'landing_page',
    LINK_URL: 'link_url',
} as const;

export const PATHFINDER = {
    STORE: 'store',
    SEARCH: 'search_gigs',
    CATEGORY: 'short_category',
    SUB_CATEGORY: 'short_category_sub_category',
    NESTED_SUB_CATEGORY: 'short_category_nested_sub_category',
    SUB_CATEGORY_STATIC_PAGE: 'sub_category_static_page',
    NESTED_SUB_CATEGORY_STATIC_PAGE: 'nested_sub_category_static_page',
    LOGO_MAKER_IDEAS_PAGE: 'logo_maker_buyer_ideas_page',
    CONTENT_PAGE: 'content_landing_page',
    LANDING_PAGE: 'static_page',
} as const;

export const PATHS = {
    ROOT: '#!',
};

export const OVERRIDE_ENTRY_CONFIG = {
    '5UTWBn0rLHCVMTo6mz6jZp': {
        urlParams: {
            source: 'category_tree_trending',
        },
    },
};

export const FILTER_SEPARATORS = {
    PARAMS: '|',
    PARAM_VALUE: ':',
    ARRAY_VALUE: ',',
};

export const DEFAULT_QUERY_PARAMS = {
    source: 'category_tree',
};

export const ContentfulTypes = {
    CATEGORY: 'Category',
    SUB_CATEGORY: 'Subcategory',
    NSC: 'Nested Subcategory',
    SEARCH_QUERY: 'Search Results',
    FILTERED_LISTING: 'Filtered Listing',
    LOGO_MAKER_IDEAS: 'Ideas',
    LINK_URL: 'linkUrl',
} as const;

export const CmsContentTypes = {
    VERTICAL_EXPERIENCE_PAGE: 'verticalExperiencePage',
    LANDING_PAGE: 'landingPage',
    CONTENT_PAGE: 'contentPage',
} as const;

export const CmsWebDesignTypes = {
    PANEL: 'Panel',
    LIST: 'List',
    BUCKETS: 'Buckets',
    BUCKETS_WITH_TITLE: 'Buckets with Title',
    BUCKETS_WITHOUT_TITLE: 'Buckets without Title',
};

export const UiTypes = {
    CATEGORY: 'category',
    SUB_CATEGORY: 'sub_category',
    NSC: 'nested_sub_category',
    SEARCH_QUERY: 'search_query',
    STATIC: 'static',
    STORE: 'store',
    FILTERED_SC: 'filtered_sub_category',
    LOGO_MAKER_IDEAS: 'ideas',
    CONTENT_PAGE: 'content_page',
    LANDING_PAGE: 'landing_page',
    LINK_URL: 'link_url',
} as const;

export const UiMenuTypes = {
    MULTI_PANEL: 'multi_panel',
    DEFAULT: 'default',
    BUCKET: 'bucket',
    BUCKETS_WITH_TITLE: 'buckets_with_title',
    BUCKETS_WITHOUT_TITLE: 'buckets_without_title',
} as const;
